//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UMUM from "../../library/umum";

export default {
  data() {
    return {
      form : {
            id : '',
            uraian : '',
            alamat : '',
            noreg : '',
            no_perdes_pembentukan : '',
            sop : '',
            ad_art : '',
            status_kantor : '',
            buku_tamu : '',
            perabot_kantor : '',
            sarana_penunjang : '',
            profil: '',
            createdAt : '',
            des_kel : this.$store.state.ID_DES_KEL,
            kecamatan : '',
        },

      fileOld : '',

      listData: [],
      listKegiatan: [],

      page_limit: 10,
      page_first: 1,
      page_last: 0,
      cari_value: "",

      mdl_lihat : false,
      mdl_pelaops : false,
      mdl_usaha : false,
      mdl_pelatihan : false,
      mdl_kendaraan : false,
      mdl_sarana : false,

      UMUM: UMUM
    };
  },
  methods: {

    getView : function(){
      this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_CNT_BUMDES + "view_bumdes", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              page_limit : this.page_limit,
              cari_value: this.cari_value,
              des_kel : this.form.des_kel
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.listData = res_data.data;
              this.$store.commit("hideLoading");
              console.log(res_data);
      });
    },

    selectData : function(data){

      this.form.id = data.id
      this.form.uraian = data.uraian
      this.form.alamat = data.alamat
      this.form.noreg = data.noreg
      this.form.no_perdes_pembentukan = data.no_perdes_pembentukan
      this.form.sop = data.sop
      this.form.ad_art = data.ad_art
      this.form.status_kantor = data.status_kantor
      this.form.buku_tamu = data.buku_tamu
      this.form.perabot_kantor = data.perabot_kantor
      this.form.sarana_penunjang = data.sarana_penunjang
      this.form.profil= data.profil
      this.form.createdAt = data.createdAt
      this.form.des_kel = data.des_kel

    },

    pushKegiatan: function(id) {
      this.$router.push("/detilKegiatan?id=" + id);
    },

    cari_data: function() {
      this.page_first = 1;
      this.getView();
    },
    indexing : function(index){
        var idx = ((this.page_first-1)*this.page_limit)+index
        return idx
    },
    keWebsite(website){
      window.open(website, '_blank').focus();
    }
  },
  mounted() {
    this.$store.state.kegiatan.id = this.$route.query.id;
    // this.$store.commit('getOne')
    this.getView();
  }
};
